<template>
  <span>
    <v-tooltip bottom v-if="setting.locallySet">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="$emit('clear')">
          <v-icon>{{ mdiUndo }}</v-icon>
        </v-btn>
      </template>
      <span>Zurücksetzen</span>
    </v-tooltip>
    <v-tooltip bottom v-else-if="setting.nextFrame.source !== undefined">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" @click="$emit('set-here')">
          <v-icon>{{ mdiCrosshairsGps }}</v-icon>
        </v-btn>
      </template>
      <span>Hier festlegen</span>
    </v-tooltip>
  </span>
</template>

<script>
import { mdiUndo, mdiCrosshairsGps } from '@mdi/js'

export default {
  name: 'ResetIcon',
  props: {
    setting: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      mdiUndo,
      mdiCrosshairsGps,
    }
  },
}
</script>
